@if (originalCodes.length) {
  <div class="mb-4">
    <diagnosis-original-codes [originalCodes]="originalCodes" />
  </div>
}

@if (!viewOnly) {
  <div>
    <p-panel header="Search for the applicable ICD-10 codes" [toggleable]="false" *accessView="['Diagnosis.Write']"
             data-test-id="icd-codes-header-label">
      <form [formGroup]="searchForm">
        <div class="flex items-center gap-4">
          <div class="field mb-0!">
            <label for="icdSearch" class="label pr-4" data-test-id="icd-search-label"><span class="is-required">*</span>ICD-10
              Code: </label>
            <input id="icdSearch" pInputText type="text" formControlName="icdSearch" tabindex="1"
                   data-test-id="icd-search-value">
          </div>
          <button
            pButton
            type="button"
            label="Search"
            class="p-button-raised"
            icon="pi pi-search"
            iconPos="left"
            [loading]="isLoading"
            [disabled]="searchForm.invalid"
            (click)="searchICD()"
            data-test-id="icd-search-button"
          ></button>
        </div>
      </form>
    </p-panel>

    <form [formGroup]="diagnosisForm">
      @if (!isPrimaryPdgm) {
        <div class="error font-semibold m-4">
          {{ primaryICDisNotPDGM }}
        </div>
      }
      <div class="grid md:grid-cols-2 gap-4 my-4">
        <div *accessView="['Diagnosis.Write']">
          <p-panel [toggleable]="false" header="Select up to 4 ICD codes" data-test-id="available-icd-list-label">
            <p-listbox
              formControlName="selectedIcd"
              data-test-id="available-icd-list-listbox"
              [options]="availableIcds"
              [listStyle]="{ 'max-height': '18rem' }"
              [style]="{ 'height': '18rem' }"
              [readonly]="!canAddMoreIcds"
              (onClick)="icdListBoxClick($event)"
            >
              <ng-template let-icd let-i="index" pTemplate="item">
                <div
                  class="flex flex-1 justify-between items-center"
                  [attr.data-test-id]=" 'available-icd-item' + i + '-value'"
                >
                  {{ icd.label }}
                </div>
              </ng-template>
            </p-listbox>
          </p-panel>
        </div>
        <div>
          <p-panel
            [toggleable]="false"
            header="Click the up or down buttons to re-assign Primary, Secondary, Tertiary, and Quaternary codes"
            data-test-id="selected-icd-list-label"
          >
            <p-listbox
              [options]="selectedIcds"
              [listStyle]="{ 'max-height': '18rem' }"
              [style]="{ 'height': '18rem' }"
              class="listbox-item-selectable-text"
              data-test-id="selected-icd-list-listbox"
            >
              <ng-template let-icd let-i="index" pTemplate="item">
                <div class="flex flex-1 justify-between items-center">
                  <div class="col" [attr.data-test-id]="'selected-icd-item' + i + '-value'">{{ icd.label }}</div>
                  <div class="grow-0 shrink-0 basis-auto" *accessView="['Diagnosis.Write']">
                    <button
                      pButton
                      type="button"
                      class="p-button-sm mr-2"
                      [disabled]="i === 0"
                      icon="pi pi-chevron-up"
                      iconPos="left"
                      (click)="moveSelctedIcdUp(icd.value)"
                      data-test-id="selected-icd-up-button"
                    ></button>
                    <button
                      pButton
                      type="button"
                      class="p-button-sm mr-2"
                      [disabled]="selectedIcds.length - 1 === i"
                      icon="pi pi-chevron-down"
                      iconPos="left"
                      (click)="moveSelctedIcdDown(icd.value)"
                      data-test-id="selected-icd-down-button"
                    ></button>
                    <button
                      pButton
                      type="button"
                      class="p-button-text p-button-sm"
                      icon="pi pi-times"
                      iconPos="left"
                      (click)="icdSelectedListBoxClick(icd.value)"
                      data-test-id="selected-icd-delete-button"
                    ></button>
                  </div>
                </div>
              </ng-template>
            </p-listbox>
          </p-panel>
        </div>
      </div>
      <div class="flex justify-end" *accessView="['Diagnosis.Write']">
        @if (!viewOnly) {
          <button
            pButton
            type="button"
            label="Save ICD Codes"
            severity="secondary"
            (click)="saveICDCodes()"
            [disabled]='!isICDAddedRemoved'
            data-test-id="selected-icd-save-button">
          </button>
        }
      </div>
    </form>
  </div>
} @else {
  <p-panel [toggleable]="false" header="Primary, Secondary, Tertiary, and Quaternary codes">
    <div class="p-listbox">
      @for (icd of selectedIcds; track icd.value) {
        <div class="p-listbox-list">
          <div class="p-listbox-item">{{ icd.label }}</div>
        </div>
      }
    </div>
  </p-panel>
}

